/* CODE storefront — vanilla JS, no dependencies */
(() => {
  'use strict';
  const C = window.CODE || { routes: {}, t: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const RTL = document.documentElement.dir === 'rtl';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('no-motion');
  const root = (C.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money ---------- */
  const fmt = (cents) => {
    const n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    const [i, d] = n.split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (d ? '.' + d : '');
  };
  const moneyHTML = (cents) => {
    const tpl = $('#c-money-tpl');
    if (!tpl) return fmt(cents);
    const el = tpl.content.firstElementChild.cloneNode(true);
    const n = el.querySelector('.c-money__n'); if (n) n.textContent = fmt(cents);
    return el.outerHTML;
  };

  /* ---------- Toast ---------- */
  let toastT;
  const toast = (msg) => {
    const t = $('.c-toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    t.style.animation = 'none'; void t.offsetWidth; t.style.animation = '';
    clearTimeout(toastT); toastT = setTimeout(() => (t.hidden = true), 2600);
  };

  /* ---------- Reveal ---------- */
  const revealAll = () => {
    const els = $$('[data-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ents) => ents.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((e, i) => { e.style.transitionDelay = (e.closest('.c-grid,.c-pay__grid') ? (i % 4) * 60 : 0) + 'ms'; io.observe(e); });
  };

  /* ---------- Panels (menu / search / cart / filters) ---------- */
  const scrim = $('[data-scrim]');
  let openPanel = null, lastFocus = null;
  const panel = (name) => $(`[data-panel="${name}"]`);
  const open = (name, trigger) => {
    const p = panel(name); if (!p) return false;
    if (openPanel && openPanel !== p) close(true);
    lastFocus = trigger || document.activeElement;
    p.hidden = false; scrim.hidden = false;
    requestAnimationFrame(() => { p.classList.add('is-open'); scrim.classList.add('is-on'); });
    document.documentElement.classList.add('is-locked');
    $$(`[data-open="${name}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    openPanel = p;
    setTimeout(() => {
      const f = p.querySelector('[data-predictive-input]') || p.querySelector('button, a, input');
      f && f.focus({ preventScroll: true });
    }, 60);
    return true;
  };
  const close = (instant) => {
    const p = openPanel; if (!p) return;
    p.classList.remove('is-open'); scrim.classList.remove('is-on');
    $$('[aria-expanded="true"][data-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    const done = () => { p.hidden = true; if (!openPanel) scrim.hidden = true; };
    openPanel = null;
    document.documentElement.classList.remove('is-locked');
    instant ? done() : setTimeout(done, 380);
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) {
      const name = o.dataset.open;
      if (name === 'cart' && C.cartType === 'page') return;
      if (open(name, o)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') || e.target === scrim) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { if ($('.c-qa.is-open')) closeQA(); else if (openPanel) close(); }
    if (e.key === 'Tab' && openPanel) {
      const f = $$('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select,textarea,summary', openPanel).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header scroll state + island ---------- */
  const hdr = $('[data-header]');
  const island = $('.c-island');
  let lastY = scrollY, ticking = false;
  const onScroll = () => {
    const y = scrollY;
    if (hdr) hdr.classList.toggle('is-scrolled', y > 40);
    if (island) island.classList.toggle('is-hidden', y > lastY + 4 && y > 300);
    if (island && y < lastY - 4) island.classList.remove('is-hidden');
    lastY = y; ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- Top bar rotator ---------- */
  $$('[data-rotator]').forEach((r) => {
    const msgs = $$('.c-topbar__msg', r); if (msgs.length < 2 || reduce) return;
    let i = 0;
    setInterval(() => { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, +r.dataset.interval || 3000);
  });

  /* ---------- Cart ---------- */
  const SECTION = 'c-cart-drawer';
  const setCount = (n) => $$('[data-cart-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
  const renderDrawer = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-root]');
    const cur = $('[data-cart-root]');
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; cur.dataset.count = fresh.dataset.count; setCount(+fresh.dataset.count || 0); }
  };
  const refreshCart = async () => {
    const r = await fetch(`${root}?sections=${SECTION}`); const j = await r.json(); renderDrawer(j[SECTION]);
  };
  const addToCart = async (items, btn, go) => {
    btn && btn.classList.add('is-loading');
    try {
      const r = await fetch(`${C.routes.cartAdd}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: SECTION, sections_url: location.pathname })
      });
      const j = await r.json();
      if (!r.ok || j.status) { toast(j.description || j.message || C.t.error); return false; }
      if (go) { location.href = `${root}checkout`; return true; }
      if (j.sections) renderDrawer(j.sections[SECTION]); else await refreshCart();
      if (C.cartType === 'page') { location.href = C.routes.cart; return true; }
      closeQA(); open('cart');
      return true;
    } catch (e) { toast(C.t.error); return false; }
    finally { btn && btn.classList.remove('is-loading'); }
  };
  const changeLine = async (line, quantity) => {
    const el = $(`[data-cart-root] [data-line="${line}"]`); el && el.classList.add('is-busy');
    try {
      const r = await fetch(`${C.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: SECTION, sections_url: location.pathname })
      });
      const j = await r.json();
      if (!r.ok || j.status) { toast(j.description || C.t.error); el && el.classList.remove('is-busy'); return; }
      renderDrawer(j.sections && j.sections[SECTION]);
    } catch (e) { toast(C.t.error); el && el.classList.remove('is-busy'); }
  };
  // drawer + cart page qty controls
  document.addEventListener('click', (e) => {
    const page = e.target.closest('[data-cart-page]');
    const btn = e.target.closest('[data-qty-change]');
    const rm = e.target.closest('[data-remove]');
    const lineEl = (btn || rm) && (btn || rm).closest('[data-line]');
    if (!lineEl) return;
    e.preventDefault();
    const line = +lineEl.dataset.line;
    const input = lineEl.querySelector('[data-qty-input]');
    const q = rm ? 0 : Math.max(0, (+input.value || 0) + (+btn.dataset.qtyChange));
    if (page) {
      lineEl.classList.add('is-busy');
      fetch(`${C.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: q }) })
        .then(() => location.reload());
    } else { input.value = q; changeLine(line, q); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]'); if (!input) return;
    const lineEl = input.closest('[data-line]'); if (!lineEl) return;
    if (input.closest('[data-cart-page]')) {
      fetch(`${C.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +lineEl.dataset.line, quantity: Math.max(0, +input.value || 0) }) }).then(() => location.reload());
    } else changeLine(+lineEl.dataset.line, Math.max(0, +input.value || 0));
  });
  // simple quick-add forms (single variant)
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-quick-add-form]'); if (!f) return;
    e.preventDefault();
    addToCart([{ id: +f.querySelector('[name=id]').value, quantity: +(f.querySelector('[name=quantity]') || { value: 1 }).value || 1 }], f.querySelector('button'));
  });

  /* ---------- Ask for a missing option (size) ---------- */
  const needOption = (fsList) => {
    const fs = fsList.find((f) => !f.querySelector('input:checked')); if (!fs) return;
    fs.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    fs.classList.remove('is-need'); void fs.offsetWidth; fs.classList.add('is-need');
    setTimeout(() => fs.classList.remove('is-need'), 1600);
    toast(C.t.chooseSize);
  };
  const isSizeName = (n) => /size|مقاس/i.test(n || '');

  /* ---------- Quick add sheet ---------- */
  let qa;
  const closeQA = () => { if (!qa) return; qa.classList.remove('is-open'); scrim.classList.remove('is-on'); setTimeout(() => { qa && qa.remove(); qa = null; if (!openPanel) scrim.hidden = true; }, 380); document.documentElement.classList.remove('is-locked'); };
  const quickAdd = async (handle, btn) => {
    btn && btn.classList.add('is-loading');
    let p;
    try { p = await (await fetch(`${root}products/${handle}.js`)).json(); } catch (e) { toast(C.t.error); return; }
    finally { btn && btn.classList.remove('is-loading'); }
    const avail = p.variants.filter((v) => v.available);
    if (!avail.length) { toast(C.t.soldOut); return; }
    const single = p.variants.length === 1;
    const sel = ((avail[0] || p.variants[0]).options || []).slice();
    if (!single) p.options.forEach((o, oi) => { if (isSizeName(o.name || o)) sel[oi] = null; });   // customer picks the size
    const img = p.featured_image ? `<img src="${p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_500x$1$2')}" alt="">` : '';
    qa = document.createElement('div');
    qa.className = 'c-qa c-qa--order'; qa.setAttribute('role', 'dialog'); qa.setAttribute('aria-modal', 'true'); qa.setAttribute('aria-label', p.title);
    qa.innerHTML = `<div class="c-qa__card"><button class="c-iconbtn c-qa__x" type="button" data-qa-close aria-label="${C.t.close}">✕</button><a class="c-qa__img" href="${p.url}">${img}</a><div class="c-qa__body"><p class="c-qa__vendor"></p><p class="c-qa__title"></p><div class="c-price c-price--md" data-qa-price></div><div data-qa-opts></div><div class="c-qa__qtyrow"><span class="c-opt__label">${C.t.quantity}</span><div class="c-qty"><button type="button" data-qa-q="-1" aria-label="−">−</button><input type="number" min="1" value="1" inputmode="numeric" data-qa-qty aria-label="${C.t.quantity}"><button type="button" data-qa-q="1" aria-label="+">+</button></div></div><button class="c-btn c-btn--block c-btn--lg c-qa__order" type="button" data-qa-order></button><button class="c-btn c-btn--ghost c-btn--block" type="button" data-qa-add></button><a class="c-link-under c-qa__more" href="${p.url}">${C.t.viewDetails}</a></div></div>`;
    qa.querySelector('.c-qa__title').textContent = p.title;
    qa.querySelector('.c-qa__vendor').textContent = (C.hiddenVendors || []).includes((p.vendor || '').toLowerCase()) ? '' : (p.vendor || '');
    const optsWrap = qa.querySelector('[data-qa-opts]');
    if (!single) p.options.forEach((o, oi) => {
      const fs = document.createElement('fieldset'); fs.className = 'c-opt';
      fs.innerHTML = `<legend class="c-opt__label"></legend><div class="c-opt__grid"></div>`;
      fs.querySelector('legend').textContent = RTL && isSizeName(o.name || o) ? 'المقاس' : (o.name || o);
      const grid = fs.querySelector('.c-opt__grid');
      (o.values || []).forEach((val) => {
        const l = document.createElement('label'); l.className = 'c-opt__btn';
        l.innerHTML = `<input type="radio" name="qa${oi}"><span></span>`;
        l.querySelector('input').value = val; l.querySelector('span').textContent = val;
        if (sel[oi] === val) l.querySelector('input').checked = true;
        grid.appendChild(l);
      });
      optsWrap.appendChild(fs);
    });
    const addBtn = qa.querySelector('[data-qa-add]'), orderBtn = qa.querySelector('[data-qa-order]'), qtyIn = qa.querySelector('[data-qa-qty]');
    let cur = null;
    const qty = () => Math.max(1, Math.min(99, parseInt(qtyIn.value, 10) || 1));
    const missing = () => sel.some((x) => x == null);
    const paint = () => {
      const v = cur, ok = !!(v && v.available), need = !v && missing();
      const pr = v || { price: p.price, compare_at_price: p.compare_at_price };
      const lbl = `<span class="c-price__label">${C.t.priceLabel}</span>`;
      qa.querySelector('[data-qa-price]').innerHTML = (v || need) ? lbl + `<span class="c-price__now">${moneyHTML(pr.price)}</span>` + (pr.compare_at_price > pr.price ? `<s class="c-price__was">${moneyHTML(pr.compare_at_price)}</s>` : '') : '';
      qa.querySelector('[data-qa-price]').classList.toggle('is-sale', !!(pr.compare_at_price > pr.price));
      addBtn.disabled = orderBtn.disabled = !(ok || need);
      addBtn.textContent = ok || need ? C.t.addToCart : (v ? C.t.soldOut : C.t.unavailable);
      orderBtn.innerHTML = need ? C.t.chooseSize : ok ? `<span>${C.t.orderNow}</span><span class="c-qa__dot">·</span>${moneyHTML(v.price * qty())}` : (v ? C.t.soldOut : C.t.unavailable);
    };
    const update = () => {
      if (single) { cur = p.variants[0]; paint(); return; }
      $$('fieldset', optsWrap).forEach((fs, oi) => { const c = fs.querySelector('input:checked'); sel[oi] = c ? c.value : null; });
      cur = p.variants.find((x) => x.options.every((o, i) => o === sel[i])) || null;
      $$('fieldset', optsWrap).forEach((fs, oi) => $$('.c-opt__btn', fs).forEach((l) => {
        const val = l.querySelector('input').value;
        const ok = p.variants.some((x) => x.available && x.options[oi] === val && x.options.every((o, i) => i === oi || !sel[i] || o === sel[i]));
        l.classList.toggle('is-na', !ok);
      }));
      paint();
    };
    optsWrap.addEventListener('change', update);
    qa.addEventListener('click', (e) => { const q = e.target.closest('[data-qa-q]'); if (!q) return; qtyIn.value = Math.max(1, Math.min(99, qty() + +q.dataset.qaQ)); paint(); });
    qtyIn.addEventListener('input', paint);
    const needInQA = () => { if (missing()) { needOption($$('fieldset', optsWrap)); return true; } return false; };
    addBtn.addEventListener('click', () => { if (needInQA()) return; cur && cur.available && addToCart([{ id: cur.id, quantity: qty() }], addBtn); });
    orderBtn.addEventListener('click', () => { if (needInQA()) return; cur && cur.available && addToCart([{ id: cur.id, quantity: qty() }], orderBtn, true); });
    qa.querySelector('[data-qa-close]').addEventListener('click', closeQA);
    document.body.appendChild(qa); update();
    if (openPanel) close(true);
    scrim.hidden = false; document.documentElement.classList.add('is-locked');
    requestAnimationFrame(() => { qa.classList.add('is-open'); scrim.classList.add('is-on'); });
    setTimeout(() => (qa.querySelector('input:checked') || qa.querySelector('.c-opt input') || orderBtn).focus({ preventScroll: true }), 80);
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (b) { e.preventDefault(); quickAdd(b.dataset.quickAdd, b); }
    if (qa && e.target === scrim) closeQA();
  });
  const addHandle = (el, btn) => {
    if (!el) return;
    if (el.dataset.available === 'false') { toast(C.t.soldOut); return; }
    quickAdd(el.dataset.handle, btn);
  };

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-copy]'); if (!b) return;
    const txt = b.dataset.copy, orig = b.textContent;
    try { await navigator.clipboard.writeText(txt); } catch (err) {
      const t = document.createElement('textarea'); t.value = txt; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e2) {} t.remove();
    }
    b.textContent = b.dataset.copied || orig; b.classList.add('is-done'); toast(`${b.dataset.copied || ''} · ${txt}`);
    setTimeout(() => { b.textContent = orig; b.classList.remove('is-done'); }, 2200);
  });

  const waLink = (a) => {
    const u = new URL(location.href); u.searchParams.delete('preview_theme_id'); u.searchParams.delete('_pos'); u.searchParams.delete('_sid'); u.searchParams.delete('_ss'); u.hash = '';
    const msg = (C.t.waMsg || '%T%').replace('%T%', a.dataset.waTitle || document.title);
    a.href = `https://wa.me/${a.dataset.wa}?text=${encodeURIComponent(`${msg} ${u.toString()}`)}`;
  };
  ['pointerdown', 'focusin', 'click'].forEach((ev) => document.addEventListener(ev, (e) => { const a = e.target.closest && e.target.closest('[data-wa]'); if (a) waLink(a); }, true));

  const initSections = (scope = document) => {
  /* ---------- Coverflow ---------- */
  $$('[data-coverflow]', scope).forEach((sec) => {
    const track = $('[data-cover-track]', sec), slides = $$('[data-cover-slide]', sec), dots = $('[data-dots]', sec);
    if (!track || !slides.length) return;
    dots.innerHTML = slides.map(() => '<i></i>').join('');
    const dotEls = $$('i', dots);
    let active = 0, raf;
    const measure = () => {
      const tr = track.getBoundingClientRect(); const mid = tr.left + tr.width / 2;
      let best = 0, bestD = Infinity;
      slides.forEach((s, i) => {
        const r = s.getBoundingClientRect(); const c = r.left + r.width / 2;
        const d = Math.abs(c - mid); const p = Math.max(0, 1 - d / (r.width * 1.15));
        s.style.setProperty('--p', p.toFixed(3));
        if (d < bestD) { bestD = d; best = i; }
      });
      if (best !== active || !slides[active].classList.contains('is-active')) {
        slides.forEach((s, i) => s.classList.toggle('is-active', i === best));
        dotEls.forEach((d, i) => d.classList.toggle('is-on', i === best));
        active = best;
      }
      raf = null;
    };
    track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(measure); }, { passive: true });
    addEventListener('resize', measure);
    const go = (i) => { const s = slides[Math.max(0, Math.min(slides.length - 1, i))]; track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); };
    // RTL: offsetLeft works in both directions for scrollTo in modern browsers
    $('[data-cover-prev]', sec).addEventListener('click', () => go(active - 1));
    $('[data-cover-next]', sec).addEventListener('click', () => go(active + 1));
    $('[data-cover-add]', sec).addEventListener('click', (e) => addHandle(slides[active], e.currentTarget));
    if (slides.length > 2) setTimeout(() => go(1), 50); else measure();
    setTimeout(measure, 120);
  });

  /* ---------- Snap index counters ---------- */
  $$('[data-snapper]', scope).forEach((sec) => {
    const track = $('[data-snap-track]', sec), items = $$('[data-snap-item]', sec), out = $('[data-snap-index]', sec);
    if (!track || !out) return;
    track.addEventListener('scroll', () => {
      const w = items[0].getBoundingClientRect().width + 12;
      const i = Math.min(items.length - 1, Math.round(Math.abs(track.scrollLeft) / w));
      out.textContent = String(i + 1).padStart(2, '0');
    }, { passive: true });
  });

  /* ---------- Brands filter + progress ---------- */
  $$('[data-brands]', scope).forEach((sec) => {
    const track = $('[data-progress-track]', sec), fill = $('[data-progress-fill]', sec), from = $('[data-progress-from]', sec);
    const cards = $$('.c-brand', sec);
    const prog = () => {
      if (!track || !fill) return;
      const max = track.scrollWidth - track.clientWidth; const pr = max > 0 ? Math.abs(track.scrollLeft) / max : 1;
      fill.style.width = Math.max(8, pr * 100) + '%';
      const vis = cards.filter((c) => !c.classList.contains('is-hidden'));
      if (from) from.textContent = String(Math.max(1, Math.round(pr * (vis.length - 1)) + 1)).padStart(2, '0');
    };
    track && track.addEventListener('scroll', prog, { passive: true }); prog();
    $$('[data-brand-filter]', sec).forEach((b) => b.addEventListener('click', () => {
      $$('[data-brand-filter]', sec).forEach((x) => x.classList.toggle('is-on', x === b));
      const g = b.dataset.brandFilter;
      cards.forEach((c) => c.classList.toggle('is-hidden', g !== '*' && c.dataset.brandGroup !== g));
      track.scrollTo({ left: 0 }); prog();
    }));
  });

  /* ---------- Deck ---------- */
  $$('[data-deck]', scope).forEach((sec) => {
    const cards = $$('[data-deck-card]', sec), idx = $('[data-deck-index]', sec);
    if (!cards.length) return;
    let i = 0;
    const show = (n, dir) => {
      const prev = i; i = (n + cards.length) % cards.length;
      cards.forEach((c, k) => { c.classList.toggle('is-on', k === i); c.classList.toggle('is-prev', k === prev && dir > 0); c.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      idx.textContent = String(i + 1).padStart(2, '0');
    };
    $('[data-deck-prev]', sec).addEventListener('click', () => show(i - 1, -1));
    $('[data-deck-next]', sec).addEventListener('click', () => show(i + 1, 1));
    $('[data-deck-add]', sec).addEventListener('click', (e) => addHandle(cards[i], e.currentTarget));
    let sx = null;
    const stack = $('[data-deck-stack]', sec);
    stack.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
    stack.addEventListener('touchend', (e) => {
      if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) { const fwd = RTL ? dx > 0 : dx < 0; show(i + (fwd ? 1 : -1), fwd ? 1 : -1); }
    });
  });

  /* ---------- Tabs (brand switch) ---------- */
  $$('[data-tabs]', scope).forEach((sec) => {
    const tabs = $$('[data-tab]', sec), panels = $$('[data-panel-tab]', sec);
    tabs.forEach((t, k) => t.addEventListener('click', () => {
      tabs.forEach((x, j) => { x.classList.toggle('is-on', j === k); x.setAttribute('aria-selected', j === k); });
      panels.forEach((p, j) => (p.hidden = j !== k));
    }));
  });

  /* ---------- Shop by style ---------- */
  $$('[data-style-switch]', scope).forEach((sec) => {
    const words = $$('[data-style-item]', sec), photos = $$('[data-style-photo]', sec), cta = $('[data-style-cta]', sec), lbl = $('[data-style-cta-label]', sec);
    let cur = 0, timer;
    const set = (k) => {
      cur = k;
      words.forEach((w, j) => w.classList.toggle('is-on', j === k));
      photos.forEach((p, j) => p.classList.toggle('is-on', j === k));
      if (cta) { cta.href = words[k].dataset.styleUrl; lbl.textContent = words[k].dataset.styleLabel; }
    };
    words.forEach((w, k) => { w.addEventListener('mouseenter', () => { clearInterval(timer); set(k); }); w.addEventListener('focus', () => set(k)); });
    if (!reduce && words.length > 1 && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        clearInterval(timer);
        if (e.isIntersecting) timer = setInterval(() => set((cur + 1) % words.length), 2600);
      }, { threshold: 0.4 }).observe(sec);
    }
  });

  };
  initSections();

  /* ---------- Predictive search ---------- */
  $$('[data-predictive]').forEach((form) => {
    const input = $('[data-predictive-input]', form), out = form.parentElement.querySelector('[data-predictive-results]');
    const initial = out.innerHTML; let t, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(t); const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = initial; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${C.routes.suggest}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=c-predictive-search`, { signal: ctrl.signal });
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const ps = doc.querySelector('.c-ps'); out.innerHTML = ps ? ps.outerHTML : '';
        } catch (e) { /* aborted */ }
      }, 220);
    });
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((sec) => {
    const form = $('[data-product-form]', sec); if (!form) return;
    const data = JSON.parse(($('[data-variants]', sec) || {}).textContent || '[]');
    const idInput = $('[data-variant-id]', form), addBtn = $('[data-add]', form), addLabel = $('[data-add-label]', form), addPrice = $('[data-add-price]', form);
    const priceWrap = $('[data-price-wrap]', sec), stock = $('[data-stock]', sec), pctEl = $('[data-pct]', sec);
    const track = $('[data-gallery-track]', sec), slides = $$('.c-gallery__slide', sec), thumbs = $$('[data-thumb]', sec);
    const fieldsets = $$('[data-option-index]', form);
    const sticky = $('[data-sticky-atc]', sec), stickyPrice = $('[data-sticky-price]', sec), stickyAdd = $('[data-sticky-add]', sec);
    const selected = () => fieldsets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const goSlide = (k, instant) => { if (!slides[k] || !track) return; track.scrollTo({ left: k * track.clientWidth * (RTL ? -1 : 1), behavior: reduce || instant ? 'auto' : 'smooth' }); };  // slides are full-width; RTL scrolls negative
    const update = () => {
      const sel = selected();
      fieldsets.forEach((fs, oi) => {
        const lab = fs.querySelector('[data-option-value]'); if (lab) lab.textContent = sel[oi] || '';
        $$('.c-opt__btn', fs).forEach((l) => {
          const val = l.querySelector('input').value;
          const ok = data.some((v) => v.available && v.options[oi] === val && v.options.every((o, i) => i === oi || sel[i] == null || o === sel[i]));
          l.classList.toggle('is-na', !ok);
        });
      });
      if (sel.some((x) => x == null)) {   // size not chosen yet: ask for it, never guess
        form.classList.add('is-nosize'); idInput.value = '';
        addBtn.disabled = false; if (stickyAdd) stickyAdd.disabled = false;
        addLabel.textContent = C.t.chooseSize; addPrice.innerHTML = '';
        if (stock) stock.textContent = '';
        return;
      }
      form.classList.remove('is-nosize');
      const v = data.find((x) => x.options.every((o, i) => o === sel[i]));
      if (!v) { addBtn.disabled = true; addLabel.textContent = C.t.unavailable; addPrice.innerHTML = ''; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; if (stickyAdd) stickyAdd.disabled = !v.available;
      addLabel.textContent = v.available ? C.t.addToCart : C.t.soldOut;
      addPrice.innerHTML = v.available ? '· ' + moneyHTML(v.price) : '';
      if (stickyPrice) stickyPrice.innerHTML = moneyHTML(v.price);
      const sale = v.compare > v.price;
      priceWrap.innerHTML = `<div class="c-price c-price--lg${sale ? ' is-sale' : ''}"><span class="c-price__label">${C.t.priceLabel}</span><span class="c-price__now">${moneyHTML(v.price)}</span>${sale ? `<s class="c-price__was">${moneyHTML(v.compare)}</s>` : ''}</div>`;
      if (pctEl) { pctEl.hidden = !sale; if (sale) pctEl.textContent = '−' + Math.round((v.compare - v.price) * 100 / v.compare) + '%'; }
      if (stock) stock.textContent = !v.available ? C.t.soldOut : (v.qty !== null && v.qty > 0 && v.qty <= 5 ? (C.t.lowStockN || '').replace('{n}', v.qty) : '');
      if (v.media) { const k = slides.findIndex((s) => +s.dataset.mediaId === v.media); if (k > -1) goSlide(k, !inited); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    form.addEventListener('change', (e) => { if (e.target.matches('[data-option]')) update(); });
    let inited = false;
    if (fieldsets.length) update();
    inited = true;
    $$('[data-qty-step]', form).forEach((b) => b.addEventListener('click', () => {
      const i = b.parentElement.querySelector('input'); i.value = Math.max(1, (+i.value || 1) + (+b.dataset.qtyStep));
    }));
    form.addEventListener('submit', (e) => {
      if (form.classList.contains('is-nosize')) { e.preventDefault(); needOption(fieldsets); return; }
      if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      const q = +form.querySelector('[name=quantity]').value || 1;
      addToCart([{ id: +idInput.value, quantity: q }], addBtn);
    });
    // gallery
    if (track && thumbs.length) {
      track.addEventListener('scroll', () => {
        const k = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        thumbs.forEach((t, j) => t.classList.toggle('is-on', j === k));
      }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => goSlide(+t.dataset.thumb)));
    }
    // lightbox
    const lb = $('[data-lightbox]', sec), lbImg = $('[data-lightbox-img]', sec);
    sec.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]');
      if (z) { lbImg.src = z.dataset.zoom; lb.hidden = false; document.documentElement.classList.add('is-locked'); $('[data-lightbox-close]', lb).focus(); }
      if (e.target.closest('[data-lightbox-close]') || e.target === lbImg) { lb.hidden = true; document.documentElement.classList.remove('is-locked'); }
    });
    // sticky ATC
    if (sticky && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(addBtn);
    }
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recs]').forEach(async (sec) => {
    if (sec.children.length) return;
    try {
      const html = await (await fetch(sec.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; revealAll(); }
    } catch (e) { /* ignore */ }
  });

  /* ---------- Load more ---------- */
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-load-more]'); if (!a) return;
    e.preventDefault(); a.classList.add('is-loading');
    try {
      const html = await (await fetch(a.href)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = $('[data-grid]'), more = a.closest('.c-more');
      $$('[data-grid] > li', doc).forEach((li) => grid.appendChild(li));
      const nextMore = doc.querySelector('.c-more');
      if (nextMore) more.replaceWith(nextMore); else more.remove();
      history.replaceState(null, '', a.href);
      revealAll();
    } catch (err) { location.href = a.href; }
  });

  /* ---------- Facets: drop empty price inputs ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-facets-form]'); if (!f) return;
    $$('input[type=number]', f).forEach((i) => { if (i.value === '') i.disabled = true; });
  });

  /* ---------- Promo popup + countdown ---------- */
  $$('[data-promo]').forEach((p) => {
    let seen = null; try { seen = localStorage.getItem(p.dataset.key); } catch (e) {}
    if (seen) return;
    setTimeout(() => (p.hidden = false), (+p.dataset.delay || 6) * 1000);
    $$('[data-promo-close]', p).forEach((b) => b.addEventListener('click', () => { p.hidden = true; try { localStorage.setItem(p.dataset.key, '1'); } catch (e) {} }));
  });
  $$('[data-countdown]').forEach((cd) => {
    const end = new Date(cd.dataset.countdown + (/[zZ+]/.test(cd.dataset.countdown.slice(10)) ? '' : '+04:00')).getTime();
    if (isNaN(end)) { cd.remove(); return; }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const d = Math.floor(s / 86400); s %= 86400; const h = Math.floor(s / 3600); s %= 3600; const m = Math.floor(s / 60); s %= 60;
      cd.querySelector('[data-d]').textContent = pad(d) + 'd'; cd.querySelector('[data-h]').textContent = pad(h) + 'h';
      cd.querySelector('[data-m]').textContent = pad(m) + 'm'; cd.querySelector('[data-s]').textContent = pad(s) + 's';
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => { initSections(e.target); revealAll(); });

  revealAll();
})();
